import { Component, OnInit } from '@angular/core';
import {RealmService} from '../Services/Realm/realm.service';
import {ApiService} from '../Services/Api/api.service';
import {SessionService} from '../Services/Session/session-service.service';
import {Router} from '@angular/router';
import {environment} from '../../environments/environment';
import {MessageService} from 'primeng/api';
import {FirebaseService} from '../Services/Firebase/firebase.service';


@Component({
  selector: 'app-home-content',
  templateUrl: './home-content.component.html',
  styleUrls: ['../../assets/layout/style/layout.css','./home-content.component.css'],
})
export class HomeContentComponent  implements OnInit {
  options: any;
  user: any;
  frontUrl: any;
  backUrl: any;
  env = environment;
  authorizations: any  = null;
  userGTM: boolean = true;
  loadingAuthorization: boolean = false;
  showCoupons = false;
  coupons: any = null;
  uploadedFiles: any[] = [];
  blob:any;
  urlImage:any;
  showCheckCoupons = false;
  showCardNumber = false;
  btnDownload: string;
  btnProviders: string;
  btnCoupons: string;
  btnCheckCoupons: string;
  titleCard: string;
  subTitleDigital: string;
  titleWelcome: string;
  countryReq: string;
  images: any[];
  countryCode : any;
  responsiveOptions:any[] = [
    {
        breakpoint: '1024px',
        numVisible: 1
    },
    {
        breakpoint: '768px',
        numVisible: 1
    },
    {
        breakpoint: '560px',
        numVisible: 1
    }
];
  
  constructor(private realm: RealmService, 
    private api: ApiService, 
    private st: SessionService, 
    private router: Router, 
    private messageService: MessageService, 
    private Rc: FirebaseService, 
    private session: SessionService) { }


  ngOnInit(): void {
    this.Rc.fetchActivate().then(() => {
      this.getRemoteConfig();
      this.getCountry();
      this.countryCode = this.session.getvvalueSession('data', 'countryCode');
     });
    this.images = [
      {
          previewImageSrc: '',
          alt: 'Frente',
          title: 'Carnet digital'
      },
      {
          previewImageSrc: '',
          alt: 'Reverso',
          title: 'Carnet digital'
      }
  ];
    this.realm.getProfileImage();
    this.env.isContentLoading = false;
    //this.urlImage = 'https://s3.amazonaws.com/gestor.documental.ambientes/GestorDocumentosSTG/502/2022/8/18/F3/2022-8-18_F3_3529.png';
    this.urlImage = "../../assets/images/avatar/avatar.png";
    this.options = [
      {label: 'Carne Digital', value: '', url: '', action: 'embeded', description: '', image: 'assets/images/new-icons/contacto.png'},
      {label: 'Reclamo', value: '*', url: 'https://reclamodigital.tecniseguros.com/reclamo-digital', action: 'newWindow', description: 'Envio de nuevo Reclamo', image: 'assets/images/new-icons/contacto.png'},
      {label: 'Emergencia', value: '*', url: '/home/emergency', action: 'navigate', description: '', image: 'assets/images/new-icons/contacto.png'},
      {label: 'Ultima Autorizacion', value: '', url: 'home/authorization', action: 'navigate', description: '', image: 'assets/images/new-icons/contacto.png'},
      {label: 'Perfil', value: '', url: 'home/profile', action: 'navigate', description: '', image: 'assets/images/new-icons/contacto.png'}
    ];
    this.realm.loginAsync().then( d => {
      const tempAuthorization = this.st.getParam('atr');
      console.log(tempAuthorization);
      if (tempAuthorization != null && tempAuthorization !== '') {
        this.authorizations = JSON.parse(tempAuthorization);
      } else {
        this.loadingAuthorization = true;
        this.env.loadingAuthorizations = true;
        this.realm.getAuthorizationSetting('', '');
      }
      //this.realm.getAuthorizationSetting('', '');
      
      this.st.getData('user').then(data => {
        this.user = data;
        console.log(data);
        this.getCard(this.user.showOldCardNumber, this.user);
      });
      this.st.getData('data').then((data:any) => {
        this.userGTM = data.countryCode;
        //this.env.usrGTM = false;
        //this.env.usrHN = true;
        console.log("userGTM: ", this.env.usrGTM );
        console.log("userHN: ", this.env.usrHN );
      });
    });
    this.realm.getCouponRenovationSettings();
    this.api.responseCouponRenovation$.subscribe( data => {
      const dat = JSON.parse(JSON.stringify(data));
      console.log("data coupons: ", dat);
      if (dat.code === 711) {
        this.showCheckCoupons = true;
      } else if (dat.code === 0) {
        this.messageService.clear();
        this.showCheckCoupons = false;
        //this.messageService.add({severity: 'info', summary: 'Información', detail: 'El usuario no tiene cupones asignados.', sticky: false});
      } else {
        // tslint:disable-next-line:max-line-length
        this.messageService.clear();
      }
    });
    this.realm.getCouponSettings();
    this.api.responseApiGetProfileImage$.subscribe(value => {
      const dat = JSON.parse(JSON.stringify(value));
      const benCmp: object = dat;
      //console.log(JSON.stringify(value) + " get profile data");
      if (dat.status === 200) {
        let data:any = dat.data;
        this.urlImage = data.url;
        //console.log("urlImage: "+this.urlImage);
      }
    });
    this.api.responseGetProfile$.subscribe(value => {
      const dat = JSON.parse(JSON.stringify(value));
      const benCmp: object = dat;
      console.log(JSON.stringify(value) + " profile component.ts 35");
      if (dat.code === 701) {
        this.env.isContentLoading = false;
        this.coupons = dat.result.success;
      }
    });
    this.realm.digitalCardUrl$.subscribe( (value: any) => {
      this.frontUrl = value.front;
      this.backUrl = value.back;
      this.options[0].value = this.frontUrl;
      this.options[0].url = this.frontUrl;
      console.log('OPTIONS:', this.options);
      this.images[0].previewImageSrc = this.frontUrl;
      this.images[1].previewImageSrc = this.backUrl;
    });
    this.api.responseAuthorization$.subscribe( data => {
      const dat = JSON.parse(JSON.stringify(data));
      console.log(dat);
      if (dat.code === 701) {
        // @ts-ignore
        const df = dat.resultAuthorizations.success;
        this.st.saveParam('atr', JSON.stringify(df[0].detail[0]));
        for (const dfKey in df) {
          console.log('authorization: ', df[dfKey].detail[0]);
          this.authorizations = df[dfKey].detail[0];
        }
      }
      this.loadingAuthorization = false;
      this.env.loadingAuthorizations = false;
    });
  }

  async getCountry() {
    this.countryReq = await this.Rc.getStringRC('country_validation');   
    //this.countryReq = 'HN'; 
    console.log('country_validation' + this.countryReq);
    this.env.usrGTM = this.countryReq == 'GT';
    this.env.usrHN = this.countryReq == 'HN';
  }

  getRemoteConfig() {
    this.btnDownload = this.Rc.getStringRC('txt_btn_download');
    this.btnProviders = this.Rc.getStringRC('txt_btn_providers');
    this.btnCoupons = this.Rc.getStringRC('txt_btn_coupons');
    this.btnCheckCoupons = this.Rc.getStringRC('txt_btn_check_coupons');
    this.titleCard = this.Rc.getStringRC('txt_title_card');
    this.subTitleDigital = this.Rc.getStringRC('txt_subtitle_digital');
    this.titleWelcome = this.Rc.getStringRC('txt_title_welcome');
  }

  getCoupons() {
    this.showCoupons = true;
  }
  getCard(showOld: boolean, dependent: any) {
    let qs = '';
    if (showOld) {
        if (dependent.policyHolderCompleteCardNumberOld.indexOf('U') > -1) {
          qs = dependent.policyHolderCompleteCardNumber;
        } else {
          qs = dependent.policyHolderCompleteCardNumberOld;
        }
    } else {
      qs = dependent.policyHolderCompleteCardNumber;
    }
    this.realm.getDigitalCard(qs);
  }
  navigate(url: string) {
    console.log("url");
    console.log(url);
    this.showCardNumber = true;
    /*
    if (url.indexOf('http') > -1) {
      window.open(url, '_blank');
    } else {
      if (url !== '') {
        this.router.navigate([url]);
      }
    }*/
  }

  navigateComponent(url: string) {
    switch (url) {
      case 'providers': {
        this.router.navigate(['home/providers']);
        break;
      }
      case 'renovations': {
        this.router.navigate(['home/providers']);
        break;
      }
      case 'coupons': {
        this.router.navigate(['home/coupons']);
        break;
      }
      case 'authorizations': {
        this.router.navigate(['home/authorization']);
        break;
      }
    }
  }

  onBasicUpload(event) {
    /*for(let file of event.files) {
        this.uploadedFiles.push(file);
    }

    this.messageService.add({severity: 'info', summary: 'File Uploaded', detail: ''});*/

    let fileReader = new FileReader();
    for (let file of event.files) {
      fileReader.readAsDataURL(file);
      fileReader.onload = function () {
          // Will print the base64 here.
          console.log(fileReader.result);
      };
    }
  }

  onBasicUploadAuto(event) {
    this.messageService.add({severity: 'info', summary: 'Success', detail: 'File Uploaded with Auto Mode'});
  }

  call(url:string){
    window.open(url);
  }

  async myUploader(event) {
    //event.files == files to upload
    let arr:any[];
    let base64:any;
    let fileReader = new FileReader();
    var file = event.files[0];
    let this2 = this;
    fileReader.readAsDataURL(file);
    fileReader.onload = (() => {
        // Will print the base64 here.
        //console.log(fileReader.result.toString().split(",")[1]);
        console.log(fileReader.result);
        base64 = fileReader.result.toString().split(",")[1];
        this.blob = base64;
    });
    setTimeout(() => {
      console.log("this.blob: "+ this.blob);
      this.realm.loadProfileImage("perfil.png", this.blob).then(() => {
        this.realm.getProfileImage();
        this.messageService.add({severity: 'info', summary: 'Carga satisfactoria', detail: 'Imagen cargada con éxito'});
      });
    }, 200)
    
  }

  
}
